import { render, staticRenderFns } from "./footer_.vue?vue&type=template&id=7e3d6a5b&"
import script from "./footer_.vue?vue&type=script&lang=js&"
export * from "./footer_.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/myz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e3d6a5b')) {
      api.createRecord('7e3d6a5b', component.options)
    } else {
      api.reload('7e3d6a5b', component.options)
    }
    module.hot.accept("./footer_.vue?vue&type=template&id=7e3d6a5b&", function () {
      api.rerender('7e3d6a5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/vue/web/page/components/footer_.vue"
export default component.exports